import React, { useState, useEffect } from "react";
import { supabase } from "../../supabaseClient";

const AdminSettingsRewards = ({ onBack }) => {
  const [loading, setLoading] = useState(false);

  // State za sve nagrade
  const [rewards, setRewards] = useState({
    total_fund: "6.000",
    first_place: "4.000",
    second_place: "1.500",
    third_place: "500",
    best_player: "Potpisani dres + pehar",
    best_scorer: "Potpisani dres + pehar",
    best_gk: "Potpisani dres + pehar",
  });

  // Učitaj podatke iz baze pri pokretanju
  useEffect(() => {
    const fetchRewards = async () => {
      const { data, error } = await supabase
        .from("site_settings") // pretpostavljeno ime tablice
        .select("*")
        .single();

      if (data && !error) {
        setRewards(data);
      }
    };
    fetchRewards();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRewards((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    setLoading(true);
    const { error } = await supabase
      .from("site_settings")
      .update(rewards)
      .eq("id", 1); // Pretpostavka da je ID postavki 1

    if (!error) {
      alert("Nagrade uspješno spremljene!");
      onBack();
    } else {
      alert("Greška pri spremanju!");
    }
    setLoading(false);
  };

  return (
    <div className="admin-settings-rewards">
      <button className="back-btn" onClick={onBack}>
        <i className="fi fi-rs-arrow-left"></i> Natrag
      </button>

      <h3>Uredi Nagradni Fond</h3>

      <div className="admin-form">
        <div className="form-group">
          <label>Ukupni Fond (€)</label>
          <input
            type="text"
            name="total_fund"
            value={rewards.total_fund}
            onChange={handleChange}
            placeholder="npr. 6.000"
          />
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>1. Mjesto (€)</label>
            <input
              type="text"
              name="first_place"
              value={rewards.first_place}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>2. Mjesto (€)</label>
            <input
              type="text"
              name="second_place"
              value={rewards.second_place}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>3. Mjesto (€)</label>
            <input
              type="text"
              name="third_place"
              value={rewards.third_place}
              onChange={handleChange}
            />
          </div>
        </div>

        <h4>Individualne Nagrade</h4>

        <div className="form-group">
          <label>Najbolji Igrač</label>
          <input
            type="text"
            name="best_player"
            value={rewards.best_player}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label>Najbolji Strijelac</label>
          <input
            type="text"
            name="best_scorer"
            value={rewards.best_scorer}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label>Najbolji Golman</label>
          <input
            type="text"
            name="best_gk"
            value={rewards.best_gk}
            onChange={handleChange}
          />
        </div>

        <button className="save-btn" onClick={handleSave} disabled={loading}>
          {loading ? "Spremanje..." : "Spremi promjene"}
        </button>
      </div>
    </div>
  );
};

export default AdminSettingsRewards;
